// src/components/StatusToast.js
import React from 'react';

/**
 * Toast resumido no intrusivo.
 * - Muestra cantidad de cambios y la última materia afectada.
 * - Autocierre controlado externamente (summary.isVisible false lo oculta).
 */
const StatusToast = ({ summary, onClose }) => {
  if (!summary?.isVisible) return null;
  return (
    <div style={{
      position: 'fixed',
      right: 16,
      bottom: 16,
      zIndex: 9999,
      background: 'var(--bg-secondary)',
      color: 'var(--text-primary)',
      border: '1px solid var(--border-color)',
      borderRadius: 10,
      padding: '10px 14px',
      boxShadow: 'var(--shadow-medium)',
      minWidth: 220,
      maxWidth: 320,
      pointerEvents: 'none'
    }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>Cambios aplicados</div>
      <div style={{ fontSize: 13, opacity: 0.9 }}>
        {summary.totalChanges} cambio(s)
        {summary.lastMateriaName ? ` • Último: ${summary.lastMateriaName}` : ''}
      </div>
      {summary.lastEstado && (
        <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>Estado: {summary.lastEstado}</div>
      )}
      {/* Cerrar manual (no bloquea el mapa) */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 6,
          right: 8,
          border: 'none',
          background: 'transparent',
          color: 'var(--text-secondary)',
          cursor: 'pointer',
          pointerEvents: 'auto'
        }}
        aria-label="Cerrar"
      >
        ×
      </button>
    </div>
  );
};

export default StatusToast;


